export const endpoints = {
  searchExternalUrlGroups: 'externalUrlGroup/search',
  deleteExternalUrlGroup: 'externalUrlGroup'
};
